<template>






  <v-row justify="center">

<v-snackbar
      v-model="mensaje.snackbar"
      :timeout="mensaje.timeout"
      :color="mensaje.color"
      text
      top
      right
    >
      {{ mensaje.text }}

      <template v-slot:action="{ attrs }">
<v-btn
          :color="mensaje.colorBtn"
          text
          v-bind="attrs"
          @click="mensaje.snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>





    <v-dialog v-model="dialogeditarproveedor" persistent max-width="600">
      <v-card>
        <v-card-title class="text-h5">
          Editar Proveedor
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field v-model="proveedor.nombre" label="Nombre" required />
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="proveedor.apellido" label="Apellido" />
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="proveedor.direccion" label="Dirección" />
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="proveedor.ci" label="CI" required />
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="proveedor.telefono" label="Teléfono" />
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="proveedor.celular" label="Celular" />
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="proveedor.email" label="Email" />
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="proveedor.estado" label="Estado" />
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="proveedor.representante" label="Representante" />
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="proveedor.ruc" label="RUC" />
              </v-col>
              <v-col cols="12">
                <v-textarea v-model="proveedor.obs" label="Observación" rows="2" />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn     color="error" @click="closeDialog">Cancelar</v-btn>
          <v-btn   color="success" @click="guardarCambios">Registrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import proveedorService from "@/services/tienda/proveedorService.js";


  import { 
   
  } from 'vuex'
export default {
  name: 'EditarProveedorDialog', // importante para el warning
  data() {
    return {

        mensaje:{
          snackbar: false,
          text: '',
          color:'',
          timeout: 5000,
      },
      dialogeditarproveedor: false,
      proveedor: {
        id: null,
        nombre: '',
        apellido: '',
        direccion: '',
        ci: '',
        telefono: '',
        celular: '',
        email: '',
        estado: '',
        representante: '',
        ruc: '',
        obs: ''
      }
    }
  },
  methods: {
    /**
     * Abre el diálogo y carga datos del proveedor
     */
    openDialog(proveedor) {
      // clonar para no modificar directo el objeto padre
      //this.proveedor = { ...proveedor }
      this.proveedor = proveedor ;
      this.dialogeditarproveedor = true
    },
    /**
     * Cierra el diálogo
     */
    closeDialog() {
      this.dialogeditarproveedor = false
    },
    /**
     * Guarda los cambios en el servidor
     */
    guardarCambios() {
      proveedorService.update(this.proveedor)
        .then(respuesta => {
          // avisar al padre que actualice su lista
          this.$emit('actualizado')
          this.closeDialog()
        }).catch((errors) =>{

          let mensajeError = 'Ha ocurrido un error:\n';

  // Recorremos el array de errores del backend
  if (errors.response && errors.response.data && errors.response.data.errors) {
    errors.response.data.errors.forEach((err, index) => {
      mensajeError += `${index + 1}. ${err}\n`;
    });
  } else {
    mensajeError += 'Error desconocido';
  }

  // Asignamos al snackbar
  this.mensaje.text = mensajeError;
  this.mensaje.snackbar = true; // debe ser boolean
  this.mensaje.color = "error"; // fondo rojo
  this.mensaje.colorBtn = "red darken-2"; // color de botón contraste


  })
        
    }
  }
}
</script>
